// Zgłasza do Sentry (client-only) sytuację, w której odczyt koszyka wróciłby
// pusty z powodu chwilowo utraconej sesji PS (backend 422), a w cache był NIEPUSTY
// koszyk — czyli dokładnie ten moment, w którym wcześniej front cicho zwijał UI
// do pustego koszyka („dodałem, a koszyk pusty").
//
// Cel: uczynić problem MIERZALNYM. Dotąd backendowy warning leciał bez kontekstu
// użytkownika (Users affected = 0), a front w ogóle nie emitował zdarzenia, bo
// maskował 422 jako sukces. Teraz mamy sygnał od strony klienta.
//
// Emitujemy RAZ na załadowanie strony (moduł-global `reported`), żeby przy serii
// nawigacji nie zasypać Sentry. Telemetria jest best-effort i nigdy nie może
// przerwać flow koszyka.

let reported = false

export function reportCartSessionLost(previous: { cartId: number, itemsCount: number }): void {
  if (!import.meta.client || reported) {
    return
  }
  reported = true

  void import('@sentry/nuxt')
    .then((Sentry) => {
      Sentry.captureMessage('cart: session lost (kept last-known cart)', {
        level: 'warning',
        tags: { area: 'cart', reason: 'session_lost' },
        extra: {
          previousCartId: previous.cartId,
          previousItemsCount: previous.itemsCount,
        },
      })
    })
    .catch(() => {
      // Never break the cart flow because of telemetry.
    })
}

// Tylko do testów — pozwala zresetować jednorazowy guard między przypadkami.
export function __resetCartSessionLostReporterForTests(): void {
  reported = false
}
